export default __webpack_public_path__ + "static/header-background-e3ad5157359222dfcb1b5b671ff6fe0e.jpg";